import { useState, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import queryString from 'utils/queryString';

const useQuery = (name, defaultValue = null, parser = val => val) => {
  const router = useRouter();
  const [value, setValue] = useState(parser(router.query[name] ?? defaultValue));

  const valueRef = useRef(value);
  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  const query = useRef(queryString.parseUrl(router.asPath).query);
  useEffect(() => {
    query.current = queryString.parseUrl(router.asPath).query;
    if (query.current[name]) {
      if (valueRef.current !== query.current[name]) {
        setValue(parser(query.current[name]));
      }
    } else {
      setValue(parser(defaultValue));
    }
  }, [router.asPath, name, defaultValue]);

  const route = useRef(router.route);
  useEffect(() => {
    route.current = router.route;
  }, [router.route]);

  const asPath = useRef(router.asPath);
  useEffect(() => {
    asPath.current = router.asPath;
  }, [router.asPath]);

  useEffect(() => {
    if (query.current[name] != null || value !== defaultValue) {
      const newQuery = {
        ...query.current,
        [name]: value,
      };

      const url = queryString.stringifyUrl(route.current, newQuery);
      const as = queryString.stringifyUrl(queryString.parseUrl(asPath.current).url, newQuery);

      router.replace(url, as, { shallow: true });
    }
  }, [name, defaultValue, value]);

  return [value, setValue];
};

export default useQuery;
